import { DeliveryService } from '@newModels';
import { RouterPreloader } from '@components/RouterPreloader';
import { ShopSettingsPaymentMethods } from '@components/settings/ShopSettingsPaymentMethods';
import { SellerPlacement } from '@components/SafePaymentBenefitsBanner';

import { useShopSettingsPaymentMethodsQuery } from './gql/graphql.v4.generated';

interface Props {
  placement: SellerPlacement,
}

export const ShopSettingsPaymentMethodsContainer: React.FC<Props> = ({
  placement,
}) => {
  const { data, loading, error } = useShopSettingsPaymentMethodsQuery({
    context: { v4: true },
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return <RouterPreloader />;
  }

  if (error) {
    throw error;
  }

  if (data?.viewer?.paymentMethods) {
    const isRozetkaDeliveryEnabled = !!data.viewer.deliverySettings.find(
      (setting) => (
        setting.deliveryService === DeliveryService.Rozetka
        && setting.isEnabled
      ),
    );

    return (
      <ShopSettingsPaymentMethods
        placement={placement}
        paymentMethods={data.viewer.paymentMethods}
        isUserRestrictedByBankId={!!data.viewer.isUserRestrictedByBankId}
        isRozetkaDeliveryEnabled={isRozetkaDeliveryEnabled}
      />
    );
  }

  throw new Error('Empty render');
};
